const Test = () => {
  return (
    <div
      style={{ minHeight: "10vh", padding: "1rem" }}
      className="bg-white"
    ></div>
  );
};

export default Test;
